export const commonDeleteDialogTranslations = {
    en: {
        confirmDeleteMessage: "Are you sure you want to delete this item? This action cannot be undone.",
        delete: "Delete",
        deleteSuccess: "Deleted Successfully!",
        deleteError: "Failed to delete"
    },
    mr: {
        confirmDeleteMessage: "तुम्हाला खात्री आहे की तुम्ही हा आयटम हटवू इच्छिता? ही क्रिया पूर्ववत केली जाऊ शकत नाही.",
        delete: "हटवा",
        deleteSuccess: "यशस्वीरित्या हटवले!",
        deleteError: "हटवण्यात अयशस्वी"
    }
};
